export default __webpack_public_path__ + "static/media/detail-view-icon.d75265d1.svg";